import { render, staticRenderFns } from "./ReportTripDetails.vue?vue&type=template&id=2a55385a&scoped=true&"
import script from "./ReportTripDetails.vue?vue&type=script&lang=ts&"
export * from "./ReportTripDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReportTripDetails.vue?vue&type=style&index=0&id=2a55385a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a55385a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VForm,VRadio,VRadioGroup,VSelect})
